










import { Component, Prop, Mixins } from "vue-property-decorator";
import VSelect, { VSelectOption } from "@/components/VSelect.vue";
import { SalesDepartment } from "../../models";
import SalesDepartmentsMixin from "@/mixins/http/SalesDepartmentsMixin";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";

const GET_SALES_DEPARTMENTS_TAG = "get_sales_departments";

@Component({ components: { VSelect } })
export default class SalesDepartmentsSelect extends Mixins(
  SalesDepartmentsMixin
) {
  @Prop({ required: true })
  readonly selected!: string | null;

  @Prop({ required: true })
  readonly placeholder!: string | null;

  @Prop()
  readonly queryKey?: string;

  @Prop({ default: false })
  readonly preselect: boolean;

  @Prop({ default: false })
  readonly actsAsFilter: boolean;

  @Prop({ required: true }) readonly companyId!: string | number;

  @RegisterHttp(GET_SALES_DEPARTMENTS_TAG) salesDepartmentsRequest: RequestData;

  get loading() {
    return this.salesDepartmentsRequest?.loading;
  }

  options: VSelectOption[] = [];

  private value: string | null = this.selected || null;

  async mounted() {
    await this.loadItems();
  }

  onSelected(id: string) {
    this.value = id;
    this.$emit("input", id);
  }

  async loadItems() {
    if (this.actsAsFilter) {
      this.options = [{ id: "all", text: "All" }];
    }

    const salesDepartments: SalesDepartment[] = await this.getSalesDepartments(
      { page: { size: "all" }, filter: { company: this.companyId } },
      GET_SALES_DEPARTMENTS_TAG
    );

    this.options.push(
      ...salesDepartments.map((s) => {
        return {
          id: s.salesUser.id,
          text: `${s.salesUser.firstName} ${s.salesUser.lastName}`,
        };
      })
    );
    if (!this.value) {
      if (this.preselect) {
        this.value = this.options[0].id;
      }
    } else {
      this.value = this.options.find((o) => o.id === this.selected)?.id;
    }
  }
}
